import React from 'react';

const PlayTriangle = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12">
    <g fill="none" fillRule="evenodd" strokeLinecap="square">
      <g stroke={color}>
        <g>
          <g>
            <g>
              <path
                d="M8 12.208L0 17.008 0 7.408z"
                transform="translate(-43 -1215) translate(0 263) translate(27 934) translate(17 12)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PlayTriangle;
